import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import Header from './header';
import Footer from './footer';
import Home from '../routes/merch-item';
import Item from '../routes/merch-item';
import ShopifyBuy from 'shopify-buy'
import Helmet from "preact-helmet";
import createHashHistory from 'history/createHashHistory';
// import Home from 'async!./home';
// import Profile from 'async!./profile';
import ReactGA from 'react-ga';

export const shopClient = ShopifyBuy.buildClient({
  accessToken: 'b330c76130ae3153072e6bff346647bd',
  domain: 'kidsuper.com',
  appId: '6'
});



ReactGA.initialize('UA-0-1');
ReactGA.pageview(window.location.pathname + window.location.search);


export default class App extends Component {
	state = {
		currentUrl: window.location.href
	}

	goToMerch = () => route('/', true);
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	// handleRoute = e => window.scrollTo(0, 0) && this.setState({currentUrl: e.url})  ;

	render() {
		return (
			<div id="app">
			
			  <Helmet
              htmlAttributes={{lang: "en", amp: undefined}} // amp takes no value
			  title="Home"
			  
               titleTemplate=" %s" />
				<Header url={this.state.currentUrl} goToMerch={this.goToMerch} />
		
				<Router  history={createHashHistory()} onChange={this.handleRoute}>
					<Home path="/" />
					<Item key="variant" path="/:handle" />
				</Router>
			
				<Footer />
				{/* <div class="divider"><img src="https://cdn.shopify.com/s/files/1/0079/0305/1834/files/Divider.png?1295029730664742318"/></div> */}

			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js